import { useAccountApi } from '@hooks/api/account/useAccountApi';
import { usePatchPutApi } from '@hooks/api/usePatchPutApi';
import { join } from '@utils/string-util';

import type { ApiOptions } from '../../../types/api';
import type { UserProfile, UserProfileRequest } from '../../../types/auth';

export const useUpdateAccount = (
  options: ApiOptions<UserProfile, UserProfileRequest> = {}
) => {
  const api = useAccountApi();

  const { update, ...response } = usePatchPutApi({
    ...options,
    getSuccessMessage: (data) =>
      `${
        data.firstName ? join([data.firstName, data.lastName]) : 'Staff member'
      } has been updated`,
    onSuccess: (data, ...args) => {
      options?.onSuccess?.(data, ...args);
    },
    request: (params) => api.update(params),
  });

  return {
    ...response,
    updateAccount: update,
  };
};
